export const initialState = {
  failed: false,
  loading: 0,
};
